class FeaturedProductsSlide {
  constructor(container) {
    this.container = container;
    this.splideInstance = null;
    this.init();
  }

  init() {
    if (!this.container || typeof Splide === 'undefined') return;

    if (this.container.featuredProductsSlide) {
      this.container.featuredProductsSlide.destroy();
    }

    this.container.featuredProductsSlide = this;
    this.mount();
  }

  mount() {
    const slideCount = this.container.querySelectorAll('.splide__slide').length;
    const desktopPerPage = Number(this.container.dataset.desktopPerPage) || 4;
    const tabletPerPage = Number(this.container.dataset.tabletPerPage) || 3;
    const mobilePerPage = Number(this.container.dataset.mobilePerPage) || 1;
    const showArrows = this.container.dataset.arrows === 'true';
    const showPagination = this.container.dataset.pagination === 'true';

    this.splideInstance = new Splide(this.container, {
      type: 'slide',
      rewind: slideCount > desktopPerPage,
      perPage: desktopPerPage,
      perMove: 1,
      gap: '10px',
      speed: 700,
      arrows: showArrows && slideCount > desktopPerPage,
      pagination: showPagination && slideCount > desktopPerPage,
      drag: slideCount > mobilePerPage,
      trimSpace: true,
      omitEnd: true,
      breakpoints: {
        991: {
          perPage: tabletPerPage,
          arrows: showArrows && slideCount > tabletPerPage,
          pagination: showPagination && slideCount > tabletPerPage,
          drag: slideCount > tabletPerPage
        },
        768: {
          perPage: mobilePerPage,
          arrows: false,
          pagination: showPagination && slideCount > mobilePerPage,
          drag: slideCount > mobilePerPage
        }
      }
    });

    this.splideInstance.mount();
  }

  destroy() {
    if (this.splideInstance) {
      this.splideInstance.destroy(true);
      this.splideInstance = null;
    }

    if (this.container) {
      this.container.featuredProductsSlide = null;
    }
  }
}

const initFeaturedProductsSlides = (scope = document) => {
  scope.querySelectorAll('[featured-products-slide-slider]').forEach((slider) => {
    if (slider.featuredProductsSlide) return;

    new FeaturedProductsSlide(slider);
  });
};

const observeFeaturedProductsSlides = (scope = document) => {
  const sliders = scope.querySelectorAll('[featured-products-slide-slider]');

  if (!sliders.length) return;

  if (!('IntersectionObserver' in window)) {
    initFeaturedProductsSlides(scope);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      observer.unobserve(entry.target);

      if (!entry.target.featuredProductsSlide) {
        new FeaturedProductsSlide(entry.target);
      }
    });
  }, {
    rootMargin: '300px 0px',
    threshold: 0.01
  });

  sliders.forEach((slider) => {
    if (!slider.featuredProductsSlide) {
      observer.observe(slider);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  observeFeaturedProductsSlides();
});

document.addEventListener('shopify:section:load', (event) => {
  initFeaturedProductsSlides(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[featured-products-slide-slider]').forEach((slider) => {
    if (slider.featuredProductsSlide) {
      slider.featuredProductsSlide.destroy();
    }
  });
});
